import React from 'react';
import { oneOf, string } from 'prop-types';
import { Chip as MuiChip, styled } from '@mui/material';

const StyledChip = styled(MuiChip, {
  shouldForwardProp: prop => prop !== 'type',
})(({ theme, type }) => ({
  borderRadius: '8px',
  borderWidth: 0,
  fontSize: '0.75rem',
  padding: '4px 8px',
  height: 'unset',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[600],

  span: {
    padding: 0,
  },

  ...(type === 'error' && {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.main,
  }),
  ...((type === 'post' || type === 'info') && {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.main,
  }),
  ...((type === 'get' || type === 'success') && {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.main,
  }),
}));

const Chip = ({ label, type, variant }) => {
  const chipVariant = type === 'post' || type === 'get' ? 'filled' : variant;
  return (
    <StyledChip
      type={type}
      label={label}
      variant={chipVariant}
    />
  );
};

export default Chip;

Chip.propTypes = {
  label: string.isRequired,
  type: oneOf(['status', 'info', 'error', 'post', 'get', 'success']),
  variant: oneOf(['filled', 'outlined']),
};

Chip.defaultProps = {
  type: 'status',
  variant: 'outlined',
};
